/* eslint-disable indent */
/* eslint-disable camelcase */
import store from '../../store'
import { setBicycleScores } from '../slices/criteriaSelection/bicycle'
import {
  BIKE_FACILITY_TYPE_VALUES,
  BUFFER_BIKE_SIDEWALK,
  BUFFER_BIKE_SIDEWALK_VALUES,
  BUFFER_BIKE_TRAVEL_LANE,
  BUFFER_BIKE_TRAVEL_LANE_VALUES,
  CURBSIDE_MANAGEMENT,
  CURBSIDE_MANAGEMENT_VALUES,
  LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS,
  LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS_VALUES,
  MID_BLOCK_CONFLICTS,
  MID_BLOCK_CONFLICTS_VALUES,
  SHARED_LANE_PAVEMENT_MARKINGS_PRESENT,
  SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES,
  SIDEWALK_WIDTH,
  SIDEWALK_WIDTH_VALUES,
  SPECIAL_CONSIDERATIONS,
  SPECIAL_CONSIDERATIONS_VALUES,
  STREET_BUFFER_WIDTH,
  STREET_BUFFER_WIDTH_VALUES,
  USABLE_BIKEWAY_WIDTH,
  USABLE_BIKEWAY_WIDTH_VALUES
} from '../constants/bike'
import { NA } from '../constants/scores'

export function calculateBikeScore(field, facilityTypeChanged) {
  const { bicycle, roadwayVariables, modalTiers } = store.getState()
  const { Bicycle: BTier } = modalTiers
  const { bike_facility_type, scores, special_considerations } = bicycle
  const { travel_lanes, prevailing_posted_speed } = roadwayVariables

  // If Bike Tier is 0 or NA , do not calculate score
  // Every score is NA
  if (BTier === 0) {
    for (const key of Object.keys(bicycle)) {
      store.dispatch(
        setBicycleScores({
          field: key,
          value: NA
        })
      )
    }
    return
  }

  if (
    bike_facility_type === BIKE_FACILITY_TYPE_VALUES[2] ||
    bike_facility_type === BIKE_FACILITY_TYPE_VALUES[4] ||
    bike_facility_type === BIKE_FACILITY_TYPE_VALUES[3] ||
    bike_facility_type === BIKE_FACILITY_TYPE_VALUES[5]
  ) {
    for (const key of Object.keys(bicycle)) {
      switch (key) {
        case LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS:
          if (field === key) {
            store.dispatch(setBicycleScores({ field, value: NA }))
          }
          // update all values when bike facility type changes and that particular field exsists
          if (facilityTypeChanged) {
            store.dispatch(setBicycleScores({ field: key, value: NA }))
          }
          break
        case SHARED_LANE_PAVEMENT_MARKINGS_PRESENT:
          if (field === key) {
            store.dispatch(setBicycleScores({ field, value: NA }))
          }
          // update all values when bike facility type changes and that particular field exsists
          if (facilityTypeChanged) {
            store.dispatch(setBicycleScores({ field: key, value: NA }))
          }
          break

        case BUFFER_BIKE_TRAVEL_LANE:
          if (prevailing_posted_speed >= 1 && prevailing_posted_speed <= 24) {
            // Incase of ONE WAY RAISED or TWO WAY RAISED
            if (
              bike_facility_type === BIKE_FACILITY_TYPE_VALUES[3] ||
              bike_facility_type === BIKE_FACILITY_TYPE_VALUES[5]
            ) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 1 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 1 }))
            } else {
              // Incase of ONE WAY ROADWAY or TWO WAY ROADWAY
              if (
                bicycle[key].includes(BUFFER_BIKE_TRAVEL_LANE_VALUES[0]) ||
                bicycle[key].includes(BUFFER_BIKE_TRAVEL_LANE_VALUES[1]) ||
                bicycle[key].includes(BUFFER_BIKE_TRAVEL_LANE_VALUES[2]) ||
                bicycle[key].includes(BUFFER_BIKE_TRAVEL_LANE_VALUES[3])
              ) {
                key === field &&
                  store.dispatch(setBicycleScores({ field, value: 1 }))
                // update all values when pedestrian facility type changes and that particular field exsists
                facilityTypeChanged &&
                  store.dispatch(setBicycleScores({ field: key, value: 1 }))
              } else {
                key === field &&
                  store.dispatch(setBicycleScores({ field, value: 2 }))
                // update all values when pedestrian facility type changes and that particular field exsists
                facilityTypeChanged &&
                  store.dispatch(setBicycleScores({ field: key, value: 2 }))
              }
            }
          } else if (
            prevailing_posted_speed >= 25 &&
            prevailing_posted_speed <= 30
          ) {
            if (
              bicycle[key].includes(BUFFER_BIKE_TRAVEL_LANE_VALUES[0]) ||
              bicycle[key].includes(BUFFER_BIKE_TRAVEL_LANE_VALUES[1]) ||
              bicycle[key].includes(BUFFER_BIKE_TRAVEL_LANE_VALUES[2])
            ) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 1 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 1 }))
            } else {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 2 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 2 }))
            }
          } else if (
            prevailing_posted_speed >= 31 &&
            prevailing_posted_speed <= 35
          ) {
            if (
              bicycle[key].includes(BUFFER_BIKE_TRAVEL_LANE_VALUES[0]) ||
              bicycle[key].includes(BUFFER_BIKE_TRAVEL_LANE_VALUES[2])
            ) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 1 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 1 }))
            } else if (
              bicycle[key].includes(BUFFER_BIKE_TRAVEL_LANE_VALUES[1])
            ) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 2 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 2 }))
            } else {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 3 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 3 }))
            }
          } else if (prevailing_posted_speed > 35) {
            if (
              bicycle[key].includes(BUFFER_BIKE_TRAVEL_LANE_VALUES[0]) ||
              bicycle[key].includes(BUFFER_BIKE_TRAVEL_LANE_VALUES[2])
            ) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 1 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 1 }))
            } else if (
              bicycle[key].includes(
                BUFFER_BIKE_TRAVEL_LANE_VALUES[1] &&
                  bicycle[key].includes(BUFFER_BIKE_TRAVEL_LANE_VALUES[3])
              )
            ) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 2 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 2 }))
            } else if (
              bicycle[key].includes(BUFFER_BIKE_TRAVEL_LANE_VALUES[1])
            ) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 3 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 3 }))
            } else {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 4 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 4 }))
            }
          }

          break
        case STREET_BUFFER_WIDTH:
          // In case of ONE WAY RAISED or TWO WAY RAISED
          if (
            bike_facility_type === BIKE_FACILITY_TYPE_VALUES[3] ||
            bike_facility_type === BIKE_FACILITY_TYPE_VALUES[5]
          ) {
            if (bicycle[key] === STREET_BUFFER_WIDTH_VALUES[0]) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 1 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 1 }))
            } else if (
              bicycle[key] === STREET_BUFFER_WIDTH_VALUES[1] ||
              bicycle[key] === STREET_BUFFER_WIDTH_VALUES[2]
            ) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 2 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 2 }))
            } else {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: NA }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: NA }))
            }
            break
          }

          if (bicycle[key] === STREET_BUFFER_WIDTH_VALUES[0]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 1 }))
          } else if (bicycle[key] === STREET_BUFFER_WIDTH_VALUES[1]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 2 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 2 }))
          } else if (bicycle[key] === STREET_BUFFER_WIDTH_VALUES[2]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 4 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 4 }))
          } else {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: NA }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: NA }))
          }
          break
        case SIDEWALK_WIDTH:
          // Sidewalk width scores are NA for In-Road Protected lanes
          if (
            bike_facility_type === BIKE_FACILITY_TYPE_VALUES[2] ||
            bike_facility_type === BIKE_FACILITY_TYPE_VALUES[4]
          ) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: NA }))

            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: NA }))
          } else {
            if (bicycle[key] === SIDEWALK_WIDTH_VALUES[0]) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 1 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 1 }))
            } else if (bicycle[key] === SIDEWALK_WIDTH_VALUES[1]) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 3 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 3 }))
            } else if (bicycle[key] === SIDEWALK_WIDTH_VALUES[2]) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 4 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 4 }))
            } else {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: NA }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: NA }))
            }
          }
          break
        case BUFFER_BIKE_SIDEWALK:
          // Sidewalk width scores are NA for In-Road Protected lanes
          if (
            bike_facility_type === BIKE_FACILITY_TYPE_VALUES[2] ||
            bike_facility_type === BIKE_FACILITY_TYPE_VALUES[4]
          ) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: NA }))

            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: NA }))
          } else {
            if (
              bicycle[key].includes(BUFFER_BIKE_SIDEWALK_VALUES[0]) ||
              bicycle[key].length > 1
            ) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 1 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 1 }))
            } else if (
              bicycle[key].length === 1 &&
              (bicycle[key].includes(BUFFER_BIKE_SIDEWALK_VALUES[1]) ||
                bicycle[key].includes(BUFFER_BIKE_SIDEWALK_VALUES[2]))
            ) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 2 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 2 }))
            } else if (
              !bicycle[key].includes(BUFFER_BIKE_SIDEWALK_VALUES[1]) &&
              !bicycle[key].includes(BUFFER_BIKE_SIDEWALK_VALUES[2])
            ) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 4 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 4 }))
            } else {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: NA }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: NA }))
            }
          }
          break
        case USABLE_BIKEWAY_WIDTH:
          if (
            bike_facility_type === BIKE_FACILITY_TYPE_VALUES[2] ||
            bike_facility_type === BIKE_FACILITY_TYPE_VALUES[3]
          ) {
            if (
              bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[0] ||
              bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[1] ||
              bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[2] ||
              bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[3] ||
              bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[4]
            ) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 1 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 1 }))
            } else if (bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[5]) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 2 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 2 }))
            } else if (
              bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[6] ||
              bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[7]
            ) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 4 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 4 }))
            } else {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: NA }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: NA }))
            }
          } else {
            if (
              bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[0] ||
              bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[1] ||
              bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[2]
            ) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 1 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 1 }))
            } else if (bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[3]) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 2 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 2 }))
            } else if (
              bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[4] ||
              bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[5] ||
              bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[6] ||
              bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[7]
            ) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 4 }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 4 }))
            } else {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: NA }))
              // update all values when pedestrian facility type changes and that particular field exsists
              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: NA }))
            }
          }
          break
        case CURBSIDE_MANAGEMENT:
          console.log(key, CURBSIDE_MANAGEMENT_VALUES[1], 3)
          if (bicycle[key] === CURBSIDE_MANAGEMENT_VALUES[0]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 1 }))
          } else if (bicycle[key] === CURBSIDE_MANAGEMENT_VALUES[1]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 3 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 3 }))
          } else {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: NA }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: NA }))
          }
          break
        case MID_BLOCK_CONFLICTS:
          if (bicycle[key] === MID_BLOCK_CONFLICTS_VALUES[0]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 1 }))
          } else if (bicycle[key] === MID_BLOCK_CONFLICTS_VALUES[1]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 2 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 2 }))
          } else if (bicycle[key] === MID_BLOCK_CONFLICTS_VALUES[2]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 4 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 4 }))
          } else {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 4 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 4 }))
          }
          break
        case SPECIAL_CONSIDERATIONS:
          if (bicycle[key].includes(SPECIAL_CONSIDERATIONS_VALUES[1])) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 3 }))
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 3 }))
          } else if (bicycle[key].includes(SPECIAL_CONSIDERATIONS_VALUES[0])) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 2 }))
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 2 }))
          } else {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 1 }))
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 1 }))
          }
          break
        default:
      }
    }
  } else if (bike_facility_type === BIKE_FACILITY_TYPE_VALUES[1]) {
    /** ----------BIKE LANE NO BUFFER-----------  */
    for (const key of Object.keys(bicycle)) {
      switch (key) {
        case LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS:
          if (field === key) {
            store.dispatch(setBicycleScores({ field, value: NA }))
          }
          // update all values when bike facility type changes and that particular field exsists
          if (facilityTypeChanged) {
            store.dispatch(setBicycleScores({ field: key, value: NA }))
          }
          break
        case SHARED_LANE_PAVEMENT_MARKINGS_PRESENT:
          if (field === key) {
            store.dispatch(setBicycleScores({ field, value: NA }))
          }
          // update all values when bike facility type changes and that particular field exsists
          if (facilityTypeChanged) {
            store.dispatch(setBicycleScores({ field: key, value: NA }))
          }
          break

        case STREET_BUFFER_WIDTH:
          if (field === key) {
            store.dispatch(setBicycleScores({ field, value: NA }))
          }
          // update all values when pedestrian facility type changes and that particular field exsists
          facilityTypeChanged &&
            store.dispatch(setBicycleScores({ field: key, value: NA }))

          break

        case BUFFER_BIKE_TRAVEL_LANE:
          if (field === key) {
            store.dispatch(setBicycleScores({ field, value: NA }))
          }
          // update all values when pedestrian facility type changes and that particular field exsists
          facilityTypeChanged &&
            store.dispatch(setBicycleScores({ field: key, value: NA }))

          break
        case BUFFER_BIKE_SIDEWALK:
          if (field === key) {
            store.dispatch(setBicycleScores({ field, value: NA }))
          }
          // update all values when pedestrian facility type changes and that particular field exsists
          facilityTypeChanged &&
            store.dispatch(setBicycleScores({ field: key, value: NA }))

          break
        case SIDEWALK_WIDTH:
          if (field === key) {
            store.dispatch(setBicycleScores({ field, value: NA }))
          }
          // update all values when pedestrian facility type changes and that particular field exsists
          facilityTypeChanged &&
            store.dispatch(setBicycleScores({ field: key, value: NA }))

          break
        case CURBSIDE_MANAGEMENT:
          if (bicycle[key] === CURBSIDE_MANAGEMENT_VALUES[0]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 1 }))
          } else if (bicycle[key] === CURBSIDE_MANAGEMENT_VALUES[1]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 3 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 3 }))
          } else {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: NA }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: NA }))
          }
          break
        case MID_BLOCK_CONFLICTS:
          if (bicycle[key] === MID_BLOCK_CONFLICTS_VALUES[0]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 1 }))
          } else if (bicycle[key] === MID_BLOCK_CONFLICTS_VALUES[1]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 2 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 2 }))
          } else if (bicycle[key] === MID_BLOCK_CONFLICTS_VALUES[2]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 4 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 4 }))
          } else {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: NA }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: NA }))
          }

          break
        case SPECIAL_CONSIDERATIONS:
          if (bicycle[key].includes(SPECIAL_CONSIDERATIONS_VALUES[1])) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 3 }))
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 3 }))
          } else if (bicycle[key].includes(SPECIAL_CONSIDERATIONS_VALUES[0])) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 2 }))
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 2 }))
          } else {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 1 }))
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 1 }))
          }
          break
        case USABLE_BIKEWAY_WIDTH:
          if (prevailing_posted_speed <= 25) {
            if (travel_lanes <= 2) {
              if (bicycle[key] === '') {
                store.dispatch(setBicycleScores({ field, value: NA }))
              } else {
                bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[6]
                  ? store.dispatch(setBicycleScores({ field, value: 2 }))
                  : bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[7]
                  ? store.dispatch(setBicycleScores({ field, value: 3 }))
                  : store.dispatch(setBicycleScores({ field, value: 1 }))
              }
            } else if (travel_lanes === 3 || travel_lanes === 4) {
              if (bicycle[key] === '') {
                store.dispatch(setBicycleScores({ field, value: NA }))
              } else {
                bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[7]
                  ? store.dispatch(setBicycleScores({ field, value: 3 }))
                  : store.dispatch(setBicycleScores({ field, value: 2 }))
              }
            } else if (travel_lanes > 4) {
              if (bicycle[key] === '') {
                store.dispatch(setBicycleScores({ field, value: NA }))
              } else {
                bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[7]
                  ? store.dispatch(setBicycleScores({ field, value: 4 }))
                  : store.dispatch(setBicycleScores({ field, value: 3 }))
              }
            }
          } else if (
            prevailing_posted_speed > 25 &&
            prevailing_posted_speed < 40
          ) {
            if (travel_lanes <= 4) {
              if (bicycle[key] === '') {
                store.dispatch(setBicycleScores({ field, value: NA }))
              } else {
                bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[7]
                  ? store.dispatch(setBicycleScores({ field, value: 3 }))
                  : store.dispatch(setBicycleScores({ field, value: 2 }))
              }
            } else if (travel_lanes > 4) {
              if (bicycle[key] === '') {
                store.dispatch(setBicycleScores({ field, value: NA }))
              } else {
                bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[7]
                  ? store.dispatch(setBicycleScores({ field, value: 4 }))
                  : store.dispatch(setBicycleScores({ field, value: 3 }))
              }
            }
          } else if (
            prevailing_posted_speed >= 40 &&
            prevailing_posted_speed < 50
          ) {
            if (travel_lanes <= 4) {
              if (bicycle[key] === '') {
                store.dispatch(setBicycleScores({ field, value: NA }))
              } else {
                bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[7]
                  ? store.dispatch(setBicycleScores({ field, value: 4 }))
                  : store.dispatch(setBicycleScores({ field, value: 3 }))
              }
            } else if (travel_lanes > 4) {
              if (bicycle[key] === '') {
                store.dispatch(setBicycleScores({ field, value: NA }))
              } else {
                store.dispatch(setBicycleScores({ field, value: 4 }))
              }
            }
          } else {
            if (travel_lanes <= 4) {
              if (bicycle[key] === '') {
                store.dispatch(setBicycleScores({ field, value: NA }))
              } else {
                bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[7] ||
                bicycle[key] === USABLE_BIKEWAY_WIDTH_VALUES[6]
                  ? store.dispatch(setBicycleScores({ field, value: 4 }))
                  : store.dispatch(setBicycleScores({ field, value: 3 }))
              }
            } else if (travel_lanes > 4) {
              if (bicycle[key] === '') {
                store.dispatch(setBicycleScores({ field, value: NA }))
              } else {
                store.dispatch(setBicycleScores({ field, value: 4 }))
              }
            }
          }
          break
        default:
      }
    }
  } else if (bike_facility_type === BIKE_FACILITY_TYPE_VALUES[0]) {
    /** ----------NO DEDICATED BIKEWAY-----------  */
    for (const key of Object.keys(bicycle)) {
      switch (key) {
        case STREET_BUFFER_WIDTH:
          if (field === key) {
            store.dispatch(setBicycleScores({ field, value: NA }))
          }
          // update all values when pedestrian facility type changes and that particular field exsists
          facilityTypeChanged &&
            store.dispatch(setBicycleScores({ field: key, value: NA }))

          break
        case CURBSIDE_MANAGEMENT:
          if (field === key) {
            store.dispatch(setBicycleScores({ field, value: NA }))
          }
          // update all values when pedestrian facility type changes and that particular field exsists
          facilityTypeChanged &&
            store.dispatch(setBicycleScores({ field: key, value: NA }))

          break
        case BUFFER_BIKE_SIDEWALK:
          if (field === key) {
            store.dispatch(setBicycleScores({ field, value: NA }))
          }
          // update all values when pedestrian facility type changes and that particular field exsists
          facilityTypeChanged &&
            store.dispatch(setBicycleScores({ field: key, value: NA }))

          break
        case BUFFER_BIKE_TRAVEL_LANE:
          if (field === key) {
            store.dispatch(setBicycleScores({ field, value: NA }))
          }
          // update all values when pedestrian facility type changes and that particular field exsists
          facilityTypeChanged &&
            store.dispatch(setBicycleScores({ field: key, value: NA }))

          break
        case SIDEWALK_WIDTH:
          if (field === key) {
            store.dispatch(setBicycleScores({ field, value: NA }))
          }
          // update all values when pedestrian facility type changes and that particular field exsists
          facilityTypeChanged &&
            store.dispatch(setBicycleScores({ field: key, value: NA }))

          break
        case SPECIAL_CONSIDERATIONS:
          if (field === key) {
            store.dispatch(setBicycleScores({ field, value: NA }))
          }
          // update all values when pedestrian facility type changes and that particular field exsists
          facilityTypeChanged &&
            store.dispatch(setBicycleScores({ field: key, value: NA }))

          break

        case LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS:
          if (
            bicycle[key] ===
            LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS_VALUES[1]
          ) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 3 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 3 }))
          } else if (
            bicycle[key] ===
            LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS_VALUES[0]
          ) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 1 }))
          } else if (
            bicycle[key] ===
            LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS_VALUES[2]
          ) {
            key === field &&
              store.dispatch(
                setBicycleScores({
                  field,
                  value: 4
                })
              )
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(
                setBicycleScores({
                  field: key,
                  value: 4
                })
              )
          } else {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: NA }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: NA }))
          }
          break
        case SHARED_LANE_PAVEMENT_MARKINGS_PRESENT:
          if (
            bicycle[key] === SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES[0]
          ) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 1 }))
          } else if (
            bicycle[key] === SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES[1]
          ) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 2 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 2 }))
          } else if (
            bicycle[key] === SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES[2]
          ) {
            // In case of NO MARKINGS, calculate score based on sppedlimit selected
            if (prevailing_posted_speed < 25) {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 2 }))

              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 2 }))
            } else {
              key === field &&
                store.dispatch(setBicycleScores({ field, value: 4 }))

              facilityTypeChanged &&
                store.dispatch(setBicycleScores({ field: key, value: 4 }))
            }
          } else {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: NA }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: NA }))
          }
          break
        case MID_BLOCK_CONFLICTS:
          if (bicycle[key] === MID_BLOCK_CONFLICTS_VALUES[0]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 1 }))
          } else if (bicycle[key] === MID_BLOCK_CONFLICTS_VALUES[1]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 2 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 2 }))
          } else if (bicycle[key] === MID_BLOCK_CONFLICTS_VALUES[2]) {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: 4 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: 4 }))
          } else {
            key === field &&
              store.dispatch(setBicycleScores({ field, value: NA }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setBicycleScores({ field: key, value: NA }))
          }
          break
        default:
      }
    }
    // Calculate usable bike width, based on speed limit

    prevailing_posted_speed >= 0 && prevailing_posted_speed < 25
      ? store.dispatch(
          setBicycleScores({ field: 'usable_bikeway_width', value: 1 })
        )
      : prevailing_posted_speed >= 25 && prevailing_posted_speed < 30
      ? store.dispatch(
          setBicycleScores({ field: 'usable_bikeway_width', value: 2 })
        )
      : prevailing_posted_speed >= 30 && prevailing_posted_speed < 35
      ? store.dispatch(
          setBicycleScores({ field: 'usable_bikeway_width', value: 3 })
        )
      : store.dispatch(
          setBicycleScores({ field: 'usable_bikeway_width', value: 4 })
        )
  }
}
